import React from 'react';
import { Swords } from 'lucide-react';
import { createIframeGame } from './IframeGameActivity';

export default createIframeGame({
  id: 'gooch',
  displayName: 'Gooch Invaders',
  shortDescription: 'Single-player arcade shooter.',
  leaderboard: 'score',
  url: 'https://gooch-invaders.pages.dev/',
  icon: Swords,
  attribution: {
    text: 'Gooch Invaders — chimthuwu',
    license: 'See repository',
    href: 'https://gooch-invaders.pages.dev/',
  },
});
